// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: #ffffff;
}

.email-header {
  position: relative;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
  margin-bottom: 10px;
  padding-top: 10px;
}

.back-button {
  position: absolute;
  left: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 2em;
  cursor: pointer;
  color: #1a73e8;
  padding: 0 10px;
  padding-bottom: 10px;
}

.email-header h1 {
  margin: 0;
  font-size: 1.5em;
  font-weight: 500;
  color: #333333;
  text-align: center;
}

.email-details {
  margin-top: 5px;
  font-size: 0.9em;
  color: black;
  display: flex;
  flex-direction: column;
}

.email-details div {
  margin-bottom: 3px;
}

.email-body {
  flex: 1 1;
  overflow-y: auto;
  white-space: pre-wrap; /* Preserve formatting */
  font-size: 1em;
  font-weight: 350;
  color: #333333;
  line-height: 1.6;
  margin-top: 10px;
}

.email-body p {
  margin: 0;
  margin-bottom: 10px;
}

.home-button {
  position: absolute;
  bottom: 80px;
  right: 20px;
  background-color: #e0e0e0;
  border: none;
  border-radius: 50%;
  padding: 10px;
  font-size: 1em;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.home-button:hover {
  background-color: #d0d0d0;
}

.attachment {
  margin-top: 10px;
  border-top: 1px solid #e0e0e0;
  padding-top: 10px;
  display: flex;
  align-items: center;
}

.attachment img {
  margin-right: 10px;
}

.attachment a {
  color: #1a73e8;
  text-decoration: none;
}

.attachment a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Email.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uGAAuG;EACvG,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB,EAAE,wBAAwB;EAC/C,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".email {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  background-color: #ffffff;\n}\n\n.email-header {\n  position: relative;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  padding-top: 10px;\n}\n\n.back-button {\n  position: absolute;\n  left: 10px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 2em;\n  cursor: pointer;\n  color: #1a73e8;\n  padding: 0 10px;\n  padding-bottom: 10px;\n}\n\n.email-header h1 {\n  margin: 0;\n  font-size: 1.5em;\n  font-weight: 500;\n  color: #333333;\n  text-align: center;\n}\n\n.email-details {\n  margin-top: 5px;\n  font-size: 0.9em;\n  color: black;\n  display: flex;\n  flex-direction: column;\n}\n\n.email-details div {\n  margin-bottom: 3px;\n}\n\n.email-body {\n  flex: 1;\n  overflow-y: auto;\n  white-space: pre-wrap; /* Preserve formatting */\n  font-size: 1em;\n  font-weight: 350;\n  color: #333333;\n  line-height: 1.6;\n  margin-top: 10px;\n}\n\n.email-body p {\n  margin: 0;\n  margin-bottom: 10px;\n}\n\n.home-button {\n  position: absolute;\n  bottom: 80px;\n  right: 20px;\n  background-color: #e0e0e0;\n  border: none;\n  border-radius: 50%;\n  padding: 10px;\n  font-size: 1em;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n}\n\n.home-button:hover {\n  background-color: #d0d0d0;\n}\n\n.attachment {\n  margin-top: 10px;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.attachment img {\n  margin-right: 10px;\n}\n\n.attachment a {\n  color: #1a73e8;\n  text-decoration: none;\n}\n\n.attachment a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
